import React, { useRef, useState, useMemo } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from '../components/ui/button';
import { Eraser, Check } from 'lucide-react';

const CANVAS_STYLE = { width: '100%', height: '96px', touchAction: 'none' };

export default function SignaturePad({ onSave, label = 'Signature', disabled = false }) {
  const sigRef = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const slugLabel = useMemo(() => label.toLowerCase().replace(/\s+/g, '-'), [label]);

  const handleClear = () => {
    sigRef.current?.clear();
    setIsEmpty(true);
  };

  const handleSave = () => {
    if (sigRef.current?.isEmpty()) return;
    const dataUrl = sigRef.current.getTrimmedCanvas().toDataURL('image/png');
    onSave(dataUrl);
  };

  return (
    <div data-testid={`signature-pad-${slugLabel}`}>
      <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider mb-1.5">{label}</p>
      <div className={`border-2 border-dashed rounded-md overflow-hidden ${disabled ? 'border-slate-100 bg-slate-50' : 'border-slate-300 bg-white'}`}>
        {disabled ? (
          <div className="h-24 flex items-center justify-center text-xs text-slate-400">Signature locked</div>
        ) : (
          <SignatureCanvas
            ref={sigRef}
            penColor="#0F172A"
            canvasProps={{ className: 'w-full', style: CANVAS_STYLE }}
            onEnd={() => setIsEmpty(false)}
          />
        )}
      </div>
      {!disabled && (
        <div className="flex gap-1.5 mt-1.5">
          <Button
            type="button"
            size="sm"
            variant="outline"
            onClick={handleClear}
            className="text-[10px] h-6 px-2"
            data-testid={`sig-clear-${slugLabel}`}
          >
            <Eraser className="w-3 h-3 mr-1" /> Clear
          </Button>
          <Button
            type="button"
            size="sm"
            onClick={handleSave}
            disabled={isEmpty}
            className="bg-slate-900 hover:bg-slate-800 text-white text-[10px] h-6 px-2"
            data-testid={`sig-save-${slugLabel}`}
          >
            <Check className="w-3 h-3 mr-1" /> Save
          </Button>
        </div>
      )}
    </div>
  );
}
